import React, { useState, useEffect } from 'react'
import { Table } from 'reactstrap';
import { useHistory } from 'react-router-dom';
import { useDispatch, useSelector } from 'react-redux';
import * as moment from 'moment';
import Tooltip from '@material-ui/core/Tooltip';
import Spinner from 'web/components/Spinner';
import AlertModal from 'web/components/AlertModal';
import { FORMAT } from 'web/components/utils/dateOfBirthValidation';
import Button from 'web/components/Button';
import infoicon from "web/assets/images/info-icon.png";
import { offerInvWithdrawApi } from 'redux/actions/withDraw';
import { Container, PalletsInformation } from './bidsStyle'
import styles from './table.module.scss';
import { fetchLanguageContentNew } from 'redux/actions/language';

const Bids = ({ offersOnInvData, callBackFun, type }) => {
    let history = useHistory();
    const dispatch = useDispatch();
    const loaderVisible = useSelector((state) => state.appReducer.loaderVisible);
    const token = localStorage.getItem('token');

    const [alertType, setAlertType] = useState();
    const [modal, setModal] = useState(false);
    const [modalContent, setModalContent] = useState('');
    const [modalLink, setModalLink] = useState('');
    const toggleModal = () => setModal(!modal);

    const currentLanguage = useSelector(state => state.language.currentLanguage)
    const languageContentNew = useSelector(state => state.language.languageContentNew)
    const [pageLanguageContents, setPageLanguageContents] = useState()
    const [headerArr, setHeaderArr] = useState([])

    useEffect(() => {
        if (languageContentNew?.MyBids_Page) setPageLanguageContents(languageContentNew.MyBids_Page)
        else dispatch(fetchLanguageContentNew(currentLanguage))
    }, [languageContentNew])

    useEffect(() => {
        setHeaderArr([
            { title: pageLanguageContents?.Bids_Content[8]?.PostName },
            // { title: pageLanguageContents?.Bids_Content[23]?.Location },
            { title: 'Type' },
            { title: 'Offer Price' },
            { title: pageLanguageContents?.Bids_Content[24]?.RequestedDate },
            { title: 'Offer Status' },
            { title: '' }
        ])
    }, [pageLanguageContents])



    const withDrawFun = async (items) => {
        let data = {
            offerId: items?.offerId,
            authId: localStorage.getItem('authId')
        }
        let response = await dispatch(offerInvWithdrawApi(data, token));;
        if (response?.success) {
            setAlertType("acknowledge")
            setModalContent(response?.data?.msg);
            setModalLink('');
            toggleModal();
        } else {
            if (response.statusCode === 401) {
                history.push('./sign-in')
                window.location.reload(false);
            } else {
                setModalContent(response?.data?.error?.message || response?.message || 'Something went wrong, please try again in some time.');
                setModalLink('');
                toggleModal();
            }
        }
    }

    const viewPostDetails = (items) => {
        let postId, prevPage = ''
        postId = items.inventoryId
        prevPage = 'offer'
        let obj = {
            id: postId.toString(),
            postType: 'PostInventory',
            prevPage: prevPage.toString()
        }
        dispatch({ type: 'DETAILS', payload: obj })
        history.push({ pathname: '/details', })
    }

    const tooltipAttach = (items) => {
        return (
            <Tooltip
                placement="bottom"
                leaveTouchDelay={10000}
                classes={{ popper: 'table-styleed-tooltip' }}
                arrow title={
                    <>
                        <ul>
                            <li>
                                <span className="col-6 text-bold">{pageLanguageContents?.Bids_Content[16]?.PalletType}</span>
                                <span className="col-6">{items?.palletType || 'NA'}</span>
                            </li>
                            <li>
                                <span className="col-6 text-bold">{pageLanguageContents?.Bids_Content[17]?.Grade}</span>
                                <span className="col-6">{items?.grade ? items?.grade : 'NA'}</span>
                            </li>
                            <li>
                                <span className="col-6 text-bold">{pageLanguageContents?.Bids_Content[18]?.Size}</span>
                                <span className="col-6">{items?.size ? items?.size : 'NA'}</span>
                            </li>
                            <li>
                                <span className="col-6 text-bold">{pageLanguageContents?.Bids_Content[19]?.Quantity}</span>
                                <span className="col-6">{`${items?.qty.toLocaleString()} (${items?.lots} lot)`}</span>
                            </li>
                        </ul>
                    </>
                }>
                <img src={infoicon} className="info-icon" alt='infoicon' /></Tooltip>
        )
    }

    const offerStatus = (status) => {
        let offerState = ''
        if (status === "Buynow-PU Placed") {
            offerState = 'Pending, Pickup';
        } else if (status === "Buynow-DEL Placed") {
            offerState = 'Pending, Delivery';
        } else {
            offerState = status
        }
        return offerState;
    }

    const tableData = (items, index) => {
        return (
            <tr key={index}>
                <td style={{ cursor: 'pointer', width: '30vw' }} onClick={() => viewPostDetails(items)}>
                    {items.postName} {tooltipAttach(items)}
                </td>
                <td style={{ width: '17vw' }}>{items?.location}</td>
                <td style={{ whiteSpace: 'nowrap', width: '17vw' }}>{`$${items?.offerPrice.toFixed(2)}, ${items?.qty.toLocaleString()} Qty`}</td>
                <td style={{ width: '17vw' }}>{moment(items.requestedDate).format(FORMAT)}</td>
                <td style={{ width: '20vw' }}>{offerStatus(items.offerStatus)}</td>
                <td style={{ width: '17vw' }}>
                    {(items?.offerStatus?.toLowerCase()?.includes('placed') && type !== 'buyNowOffers') ?
                        <Button
                            type='app-green-button'
                            handleClick={() => withDrawFun(items)}>
                            {pageLanguageContents?.Bids_Content[21]?.Withdraw}
                        </Button> : <div style={{ visibility: 'hidden', width: 'auto' }}>Withdraw</div>}
                </td>
            </tr>
        )
    }

    const tableAttach = () => {
        return (<>
            {loaderVisible && <Spinner />}
            <Table responsive>
                <thead>
                    <tr>
                        {headerArr.map((items, index) => (
                            <th key={index}>{items.title}</th>
                        ))}
                    </tr>
                </thead>
                <tbody>
                    {offersOnInvData.map((items, index) => (
                        tableData(items, index)
                    ))}
                </tbody>
            </Table>

            <AlertModal
                isOpen={modal}
                toggle={toggleModal}
                title={''}
                alertType={alertType}
                content={modalContent}
                link={modalLink}
                callBackAlert={(val) => {
                    if (val === "acknowledge") {
                        callBackFun()
                    }
                }}
            />
        </>
        )
    }
    return (
        <Container>
            <PalletsInformation>
                <div className={styles.tableContainer}>
                    {tableAttach()}
                </div>
            </PalletsInformation>
        </Container>
    )
}

export default Bids;